<template>
  <!-- eslint-disable vue/valid-v-slot -->

  <v-data-table :headers="headers" :items="values" :items-per-page="5" class="elevation-1">

    <template v-slot:top>
      <v-toolbar dark color="primary" flat>
        <v-toolbar-title>Formlar</v-toolbar-title>


      </v-toolbar>
    </template>



    <template v-slot:item.actions="{ item }">






    

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon large @click="formBasvurulariGoster(item)" v-bind="attrs" class="mx-2" v-on="on">
            mdi-database-eye
          </v-icon>
        </template>
        <span>Form Başvuruları Göster</span>
      </v-tooltip>


    </template>

  </v-data-table>
</template>
<script>
//import router from '@/router';
import Vue from 'vue';
import { rules } from '@/plugins/custom.js';
import router from '@/router/index';
import FormService from '@/services/FormService';

import DurumService from '@/services/DurumService';
import FilterUser from '@/services/FilterUserService';
import { VBtn } from 'vuetify/lib/components';
import FilterUserService from '@/services/FilterUserService';


export default {

  name: "KullaniciDegerlendirilecekFormlistesi",
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Yeni Form Tanımlama' : 'Form Güncelle'
    },
  },
  data() {
    return {

      // dgKullaniciKimlerDegerlendirecek: false,
      // selectedFilter: null,
      // selectedKullanicis: [],
      // selectedPersonel: null,
      // selectedPersonelItem: null,
      // tab: null,
      // dgBirim: false,
      // selectedBirimIds: [],
      // selectedBirimTurId: 0,
      // required: value => !!value || 'Gerekli.',
      // editedItem: {
      //   formId: null,
      //   name: "",
      //   // baslamaTarihi: (new Date()).toISOString().substr(0, 10),
      //   // bitisTarihi: new Date().toISOString().substr(0, 10),
      //   baslamaTarihi: "",
      //   bitisTarihi: "",
      //   loginGiris:false,
      //   onaylama:false,
      //   filtrelemeJson: "",
      //   durumId: 0
      // },
      // editedIndex: 0,
      // durums: [],
      // dialog: false,
      // form: null,
      // items: [],
      // filterUser: {
      //   custom: "",
      //   ogrenciProgramIds: [],
      //   pbsAkademisyenBirimIds: [],
      //   pbsIdariBirimIds: [],
      //   pbsDigerBirimIds: [],
      // },
      // degerlendirmeUser: {
      //   custom: "",
      //   ogrenciProgramIds: [],
      //   pbsAkademisyenBirimIds: [],
      //   pbsIdariBirimIds: [],
      //   pbsDigerBirimIds: [],
      // },
      headers: [

        {
          text: 'Form Adı',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Başlama Tarihi', value: 'baslamaTarihi', sortable: false },
        { text: 'Bitiş Tarihi', value: 'bitisTarihi', sortable: false },
        // { text: 'Ekleme Tarihi', value: 'eklemeTarihi', sortable: false },
        // { text: 'Durum', value: 'durum.name', sortable: false },
        { text: 'İşlem', value: 'actions', sortable: false },

      ],
      values: [],
      personels: []
    }
  },
  created() {

    this.dataBind();
  },

  methods: {
   
 

    dataBind() {
      FormService.KullaniciDegerlendirelecekFormlar().then((result) => {
        this.values = result.data;
        console.log("listForm", result.data);
      }).catch((err) => {

      });
      // DurumService.listDurums().then((result) => {
      //   this.durums = result.data;
      // }).catch((err) => {

      // });
      // FilterUserService.PbsPersonels().then((result) => {
      //   console.log("Personel:", result.data);
      //   this.personels = result.data;
      // }).catch((err) => {

      // });

    },
   
    
    formBasvurulariGoster(v) {
      // console.log("formTasarimGonder");
      router.push({ name: 'KullaniciFormData', params: { id: v.formId } })
    }
  }
}
</script>